var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-layout',{attrs:{"layout":"simple"}},[_c('page-content',{scopedSlots:_vm._u([{key:"page-title",fn:function(){return [_c('main-title')]},proxy:true}])},[_vm._v(" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }